import wT91 from "./wt9 (1).webp";
import wT92 from "./wt9 (2).webp";
import wT93 from "./wt9 (3).webp";
import wT94 from "./wt9 (4).webp";
import wT95 from "./wt9 (5).webp";
import wT96 from "./wt9 (6).webp";
import wT97 from "./wt9 (7).webp";

const wT9 = [wT91, wT92, wT93, wT94, wT95, wT96, wT97];
export default wT9;
